// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__-vEOm","alert":"SettungsInbox_alert__3SwH-"};